<template>
    <div>
        <b-dropdown dropright variant="primary" :size="size" title="Select Floating Date Ranges">
            <template v-slot:button-content>
                <i class="fas fa-calendar"></i>
            </template>
            <b-dropdown-text style="width: 200px;">
                <ul class="search-nav nav nav-tabs tabs-alt">
                    <b-nav-item :active="curTab === 'last'" @click="curTab = 'last'">Last</b-nav-item>
                    <b-nav-item :active="curTab === 'current'" @click="curTab = 'current'">Current</b-nav-item>
                </ul>

                <div class="mt-2">
                    <template v-if="curTab === 'last'">
                        <button :class="{'btn btn-sm d-block mb-1': true, 'btn-link': (!floatingDate || floatingDate.context !== 'last' || floatingDate.interval !== 'day'), 'btn-primary': (floatingDate && floatingDate.context === 'last' && floatingDate.interval === 'day')}"
                            v-on:click="setDate({context: 'last', interval: 'day'})">Yesterday</button>
                        <button :class="{'btn btn-sm d-block mb-1': true, 'btn-link': (!floatingDate || floatingDate.context !== 'last' || floatingDate.interval !== 'week'), 'btn-primary': (floatingDate && floatingDate.context === 'last' && floatingDate.interval === 'week')}"
                            v-on:click="setDate({context: 'last', interval: 'week'})">Week</button>
                        <button :class="{'btn btn-sm d-block mb-1': true, 'btn-link': (!floatingDate || floatingDate.context !== 'last' || floatingDate.interval !== 'month'), 'btn-primary': (floatingDate && floatingDate.context === 'last' && floatingDate.interval === 'month')}"
                            v-on:click="setDate({context: 'last', interval: 'month'})">Month</button>
                        <button :class="{'btn btn-sm d-block mb-1': true, 'btn-link': (!floatingDate || floatingDate.context !== 'last' || floatingDate.interval !== 'quarter'), 'btn-primary': (floatingDate && floatingDate.context === 'last' && floatingDate.interval === 'quarter')}"
                            v-on:click="setDate({context: 'last', interval: 'quarter'})">Quarter</button>
                        <div class="input-group">
                            <input type="name" class="form-control" />
                            <div class="input-group-append">Days</div>
                        </div>
                    </template>
                    <template v-if="curTab === 'current'">
                        <button :class="{'btn btn-sm d-block mb-1': true, 'btn-link': (!floatingDate || floatingDate.context !== 'current' || floatingDate.interval !== 'day'), 'btn-primary': (floatingDate && floatingDate.context === 'current' && floatingDate.interval === 'day')}"
                            v-on:click="setDate({context: 'current', interval: 'day'})">Today</button>
                        <button :class="{'btn btn-sm d-block mb-1': true, 'btn-link': (!floatingDate || floatingDate.context !== 'current' || floatingDate.interval !== 'week'), 'btn-primary': (floatingDate && floatingDate.context === 'current' && floatingDate.interval === 'week')}"
                            v-on:click="setDate({context: 'current', interval: 'week'})">Week</button>
                        <button :class="{'btn btn-sm d-block mb-1': true, 'btn-link': (!floatingDate || floatingDate.context !== 'current' || floatingDate.interval !== 'month'), 'btn-primary': (floatingDate && floatingDate.context === 'current' && floatingDate.interval === 'month')}"
                            v-on:click="setDate({context: 'current', interval: 'month'})">Month</button>
                        <button :class="{'btn btn-sm d-block mb-1': true, 'btn-link': (!floatingDate || floatingDate.context !== 'current' || floatingDate.interval !== 'quarter'), 'btn-primary': (floatingDate && floatingDate.context === 'current' && floatingDate.interval === 'quarter')}"
                            v-on:click="setDate({context: 'current', interval: 'quarter'})">Quarter</button>
                        <button :class="{'btn btn-sm d-block mb-1': true, 'btn-link': (!floatingDate || floatingDate.context !== 'current' || floatingDate.interval !== 'year'), 'btn-primary': (floatingDate && floatingDate.context === 'current' && floatingDate.interval === 'year')}"
                            v-on:click="setDate({context: 'current', interval: 'year'})">Year</button>
                    </template>
                </div>
            </b-dropdown-text>
          </b-dropdown>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        props: {
            extraData: {
                type: Object,
                default: null,
            },

            size: {
                type: String,
                default: 'sm',
            },

            initialFloating: {
                type: Object,
                default: null,
            },
        },

        data() {
            return {
                curTab: 'last',
                report_date_start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
                report_date_end: moment().format('YYYY-MM-DD'),
                floatingDate: null,
            }
        },

        methods: {

            setDate(payload){
                //Setup
                this.floatingDate = payload;

                //Payload contains context and interval
                var dates = {
                    start: null,
                    end: null,
                };

                //Check for last
                if(payload.context === 'last')
                {
                    //Build it
                    switch(payload.interval)
                    {
                        case 'day':
                            dates.start = moment().subtract(1, 'days').format("YYYY-MM-DD");
                            dates.end = moment().subtract(1, 'days').format("YYYY-MM-DD");
                            break;
                        case 'week':
                            dates.start = moment().subtract(1, 'weeks').day("Sunday").format("YYYY-MM-DD");
                            dates.end = moment().subtract(1, 'weeks').day("Saturday").format("YYYY-MM-DD");
                            break;
                        case 'month':
                            dates.start = moment().subtract(1, 'months').startOf("month").format("YYYY-MM-DD");
                            dates.end = moment().subtract(1, 'months').endOf("month").format("YYYY-MM-DD");
                            break;
                        case 'quarter':
                            dates.start = moment().subtract(1, 'quarters').startOf("quarter").format("YYYY-MM-DD");
                            dates.end = moment().subtract(1, 'quarters').endOf("quarter").format("YYYY-MM-DD");
                            break;
                    }
                }

                //Check for last
                else if(payload.context === 'current')
                {
                    //Build it
                    switch(payload.interval)
                    {
                        case 'day':
                            dates.start = moment().format("YYYY-MM-DD");
                            dates.end = moment().format("YYYY-MM-DD");
                            break;
                        case 'week':
                            dates.start = moment().day("Sunday").format("YYYY-MM-DD");
                            dates.end = moment().day("Saturday").format("YYYY-MM-DD");
                            break;
                        case 'month':
                            dates.start = moment().startOf("month").format("YYYY-MM-DD");
                            dates.end = moment().endOf("month").format("YYYY-MM-DD");
                            break;
                        case 'quarter':
                            dates.start = moment().startOf("quarter").format("YYYY-MM-DD");
                            dates.end = moment().endOf("quarter").format("YYYY-MM-DD");
                            break;
                        case 'year':
                            dates.start = moment().startOf("year").format("YYYY-MM-DD");
                            dates.end = moment().endOf("year").format("YYYY-MM-DD");
                            break;
                    }
                }

                //Emit
                this.$emit('setDate', {floating_date: this.floatingDate, dates: dates}, this.extraData);
            }
        },

        mounted() {
            if (this.initialFloating)
            {
                this.setDate(this.initialFloating);
            }
        }
    }
</script>
